import { TFunction } from '@lyearn/i18n';
import { SystemProperty } from '@/components/FilterManager/Tags/TagsAndProperties/types';
import {
  FilterOperatorEnum,
  FilterPropertyTypeEnum,
  RelativeDateFilterOperatorEnum,
  TagTypeEnum,
} from '@/types/schema';

//todo refactor
export const getTagOperatorsForReports = (t: TFunction) => {
  return {
    [TagTypeEnum.Date]: [
      {
        id: FilterOperatorEnum.Equal,
        value: FilterOperatorEnum.Equal,
        label: t('Group:Operator.On'),
      },
      {
        id: FilterOperatorEnum.LessThan,
        value: FilterOperatorEnum.LessThan,
        label: t('Group:Operator.Before'),
      },
      {
        id: FilterOperatorEnum.GreaterThan,
        value: FilterOperatorEnum.GreaterThan,
        label: t('Group:Operator.After'),
      },
      // {
      //   id: FilterOperatorEnum.Between,
      // value: FilterOperatorEnum.Between,
      //   label: t('Group:Operator.Between'),
      // },
      {
        id: FilterOperatorEnum.IsEmpty,
        value: FilterOperatorEnum.IsEmpty,
        label: t('Group:Operator.IsEmpty'),
      },
      {
        id: FilterOperatorEnum.IsNotEmpty,
        value: FilterOperatorEnum.IsNotEmpty,
        label: t('Group:Operator.IsNotEmpty'),
      },
    ],
    [TagTypeEnum.MultiSelect]: [
      {
        id: FilterOperatorEnum.In,
        value: FilterOperatorEnum.In,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.NotIn,
        value: FilterOperatorEnum.NotIn,
        label: t('Common:Filter.IsNot'),
      },
    ],
    [TagTypeEnum.SingleSelect]: [
      {
        id: FilterOperatorEnum.In,
        value: FilterOperatorEnum.In,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.NotIn,
        value: FilterOperatorEnum.NotIn,
        label: t('Common:Filter.IsNot'),
      },
    ],
    [TagTypeEnum.Number]: [
      {
        id: FilterOperatorEnum.Equal,
        value: FilterOperatorEnum.Equal,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.NotEqual,
        value: FilterOperatorEnum.NotEqual,
        label: t('Common:Filter.IsNot'),
      },
      {
        id: FilterOperatorEnum.GreaterThan,
        value: FilterOperatorEnum.GreaterThan,
        label: t('Group:Operator.GreaterThan'),
      },
      {
        id: FilterOperatorEnum.LessThan,
        value: FilterOperatorEnum.LessThan,
        label: t('Group:Operator.LessThan'),
      },
    ],
    [TagTypeEnum.Text]: [
      {
        id: FilterOperatorEnum.Contains,
        value: FilterOperatorEnum.Contains,
        label: t('Group:Operator.Contains'),
      },
      {
        id: FilterOperatorEnum.Equal,
        value: FilterOperatorEnum.Equal,
        label: t('Group:Operator.Equal'),
      },
      {
        id: FilterOperatorEnum.ContainsNot,
        value: FilterOperatorEnum.ContainsNot,
        label: t('Group:Operator.ContainsNot'),
      },
      {
        id: FilterOperatorEnum.StartsWith,
        value: FilterOperatorEnum.StartsWith,
        label: t('Group:Operator.StartsWith'),
      },
      {
        id: FilterOperatorEnum.EndsWith,
        value: FilterOperatorEnum.EndsWith,
        label: t('Group:Operator.EndsWith'),
      },
      {
        id: FilterOperatorEnum.IsEmpty,
        value: FilterOperatorEnum.IsEmpty,
        label: t('Group:Operator.IsEmpty'),
      },
      {
        id: FilterOperatorEnum.IsNotEmpty,
        value: FilterOperatorEnum.IsNotEmpty,
        label: t('Group:Operator.IsNotEmpty'),
      },
    ],
    [TagTypeEnum.User]: [
      {
        id: FilterOperatorEnum.In,
        value: FilterOperatorEnum.In,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.NotIn,
        value: FilterOperatorEnum.NotIn,
        label: t('Common:Filter.IsNot'),
      },
    ],
  };
};

export const getTagOperators = (t: TFunction) => {
  return {
    [TagTypeEnum.Date]: [
      {
        id: FilterOperatorEnum.Equal,
        value: FilterOperatorEnum.Equal,
        label: t('Group:Operator.On'),
      },
      {
        id: FilterOperatorEnum.LessThan,
        value: FilterOperatorEnum.LessThan,
        label: t('Group:Operator.Before'),
      },
      {
        id: FilterOperatorEnum.LessThanEqual,
        value: FilterOperatorEnum.LessThanEqual,
        label: t('Group:Operator.OnOrBefore'),
      },
      {
        id: FilterOperatorEnum.GreaterThan,
        value: FilterOperatorEnum.GreaterThan,
        label: t('Group:Operator.After'),
      },
      {
        id: FilterOperatorEnum.GreaterThanEqual,
        value: FilterOperatorEnum.GreaterThanEqual,
        label: t('Group:Operator.OnOrAfter'),
      },
      {
        id: FilterOperatorEnum.Between,
        value: FilterOperatorEnum.Between,
        label: t('Group:Operator.Between'),
      },
      {
        id: FilterOperatorEnum.IsEmpty,
        value: FilterOperatorEnum.IsEmpty,
        label: t('Group:Operator.IsEmpty'),
      },
      {
        id: FilterOperatorEnum.IsNotEmpty,
        value: FilterOperatorEnum.IsNotEmpty,
        label: t('Group:Operator.IsNotEmpty'),
      },
    ],
    [TagTypeEnum.MultiSelect]: [
      {
        id: FilterOperatorEnum.Is,
        value: FilterOperatorEnum.Is,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.IsNot,
        value: FilterOperatorEnum.IsNot,
        label: t('Common:Filter.IsNot'),
      },
      {
        id: FilterOperatorEnum.IsEmpty,
        value: FilterOperatorEnum.IsEmpty,
        label: t('Group:Operator.IsEmpty'),
      },
      {
        id: FilterOperatorEnum.IsNotEmpty,
        value: FilterOperatorEnum.IsNotEmpty,
        label: t('Group:Operator.IsNotEmpty'),
      },
    ],
    [TagTypeEnum.SingleSelect]: [
      {
        id: FilterOperatorEnum.Is,
        value: FilterOperatorEnum.Is,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.IsNot,
        value: FilterOperatorEnum.IsNot,
        label: t('Common:Filter.IsNot'),
      },
      {
        id: FilterOperatorEnum.IsEmpty,
        value: FilterOperatorEnum.IsEmpty,
        label: t('Group:Operator.IsEmpty'),
      },
      {
        id: FilterOperatorEnum.IsNotEmpty,
        value: FilterOperatorEnum.IsNotEmpty,
        label: t('Group:Operator.IsNotEmpty'),
      },
    ],
    [TagTypeEnum.Number]: [
      {
        id: FilterOperatorEnum.Is,
        value: FilterOperatorEnum.Is,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.IsNot,
        value: FilterOperatorEnum.IsNot,
        label: t('Common:Filter.IsNot'),
      },
      {
        id: FilterOperatorEnum.GreaterThan,
        value: FilterOperatorEnum.GreaterThan,
        label: t('Group:Operator.GreaterThan'),
      },
      {
        id: FilterOperatorEnum.LessThan,
        value: FilterOperatorEnum.LessThan,
        label: t('Group:Operator.LessThan'),
      },
      // {
      //   id: FilterOperatorEnum.Between,
      // value: FilterOperatorEnum.Between,
      //   label: t('Group:Operator.Between'),
      // },
    ],
    [TagTypeEnum.Text]: [
      {
        id: FilterOperatorEnum.Contains,
        value: FilterOperatorEnum.Contains,
        label: t('Group:Operator.Contains'),
      },
      {
        id: FilterOperatorEnum.Equal,
        value: FilterOperatorEnum.Equal,
        label: t('Group:Operator.Equal'),
      },
      {
        id: FilterOperatorEnum.ContainsNot,
        value: FilterOperatorEnum.ContainsNot,
        label: t('Group:Operator.ContainsNot'),
      },
      {
        id: FilterOperatorEnum.StartsWith,
        value: FilterOperatorEnum.StartsWith,
        label: t('Group:Operator.StartsWith'),
      },
      {
        id: FilterOperatorEnum.EndsWith,
        value: FilterOperatorEnum.EndsWith,
        label: t('Group:Operator.EndsWith'),
      },
      {
        id: FilterOperatorEnum.IsEmpty,
        value: FilterOperatorEnum.IsEmpty,
        label: t('Group:Operator.IsEmpty'),
      },
      {
        id: FilterOperatorEnum.IsNotEmpty,
        value: FilterOperatorEnum.IsNotEmpty,
        label: t('Group:Operator.IsNotEmpty'),
      },
    ],
    [TagTypeEnum.User]: [
      {
        id: FilterOperatorEnum.Is,
        value: FilterOperatorEnum.Is,
        label: t('Common:Filter.Is'),
      },
      {
        id: FilterOperatorEnum.IsNot,
        value: FilterOperatorEnum.IsNot,
        label: t('Common:Filter.IsNot'),
      },
    ],
  };
};

export type OperatorType = FilterOperatorEnum | RelativeDateFilterOperatorEnum;

export type Operator = {
  id: OperatorType;
  label: string;
};

export const getOperators = (
  t: TFunction,
  propertyType?: FilterPropertyTypeEnum,
  tagType?: TagTypeEnum,
  propertyValue?: string,
) => {
  if (!propertyType) {
    return [];
  }

  const TAG_OPERATORS = getTagOperators(t);
  if (tagType) {
    return TAG_OPERATORS[tagType];
  }

  if (propertyType === FilterPropertyTypeEnum.Field) {
    switch (propertyValue) {
      case SystemProperty.Email: {
        return [
          {
            id: FilterOperatorEnum.Contains,
            label: t('Group:Operator.Contains'),
          },
          {
            id: FilterOperatorEnum.ContainsNot,
            label: t('Group:Operator.ContainsNot'),
          },
          {
            id: FilterOperatorEnum.Equal,
            label: t('Group:Operator.Equal'),
          },
          {
            id: FilterOperatorEnum.StartsWith,
            label: t('Group:Operator.StartsWith'),
          },
        ];
      }
      case SystemProperty.EventDate: {
        return TAG_OPERATORS[TagTypeEnum.Date].filter((it) => {
          return (
            it.id !== FilterOperatorEnum.Is &&
            it.id !== FilterOperatorEnum.IsEmpty &&
            it.id !== FilterOperatorEnum.IsNotEmpty
          );
        });
      }
      case SystemProperty.DepartmentId:
      case SystemProperty.OrgRoleId: {
        return [
          {
            id: FilterOperatorEnum.Is,
            label: t('Common:Filter.Is'),
          },
          {
            id: FilterOperatorEnum.IsNot,
            label: t('Common:Filter.IsNot'),
          },
          {
            id: FilterOperatorEnum.IsEmpty,
            label: t('Common:Filter.IsEmpty'),
          },
          {
            id: FilterOperatorEnum.IsNotEmpty,
            label: t('Common:Filter.IsNotEmpty'),
          },
        ];
      }
      default: {
        return [
          {
            id: FilterOperatorEnum.Is,
            label: t('Common:Filter.Is'),
          },
          {
            id: FilterOperatorEnum.IsNot,
            label: t('Common:Filter.IsNot'),
          },
        ];
      }
    }
  }

  return [];
};

export const getSelectedOperator = (operators: Operator[], selectedOperator?: OperatorType) => {
  if (selectedOperator) {
    return operators.find((operator) => operator.id === selectedOperator);
  }
  if (!operators.length) {
    return undefined;
  }
  return operators[0];
};
